import { vuexLogistic } from '@/store/composition/module/logistic'

import { createItem, updateItem } from '@/api/defaultApi'
import { LOGISTIC_FUEL_URL } from '@/api/Logistic'

const state = () => ({
  ...vuexLogistic.createState(),
  urlApi: LOGISTIC_FUEL_URL,
  expand: 'fuel_balance,transport',
  deleteResponseKey: 'name',

  tableHeaders: [
    {
      title: 'Тип топлива',
      isSortable: false
    },
    {
      title: 'Код',
      isSortable: false
    }
  ],

  modal: {
    active: false,
    updatedId: null,
    name: '',
    code: '',
    validation: {
      name: {
        type: null,
        message: ''
      },
      code: {
        type: null,
        message: ''
      }
    }
  }
})

const getters = {
  ...vuexLogistic.createGetters(),
  getFuelModalList: state => state.modal,

  getList: state => {
    return state.list.map(item => {
      return {
        id: item.id,
        isActive: item.isActive,
        values: [
          item.name,
          item.code
        ]
      }
    })
  },

  itemIsUsed: state => {
    return state.checkedDeleteItem?.transport?.length || state.checkedDeleteItem?.fuel_balance?.length
  }
}

const mutations = {
  ...vuexLogistic.createMutations(),

  SHOW_FUEL_LIST_MODAL: (state, itemId) => {
    state.modal.active = true

    if (itemId) {
      const item = state.list
        .filter(item => {
          return item.id === itemId
        })
        .pop()

      state.modal.updatedId = itemId
      state.modal.name = item.name
      state.modal.code = item.code
    }
  },
  SET_FUEL_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_FUEL_ITEM_CODE: (state, value) => {
    state.modal.code = value
  },
  SET_FUEL_ITEM_VALIDATION: (state, valid) => {
    if (valid.name) {
      state.modal.validation.name.message = valid.name[0]
      state.modal.validation.name.type = 'error'
    }
    if (valid.code) {
      state.modal.validation.code.message = valid.code[0]
      state.modal.validation.code.type = 'error'
    }
  },
  CLEAR_FUEL_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = {
          type: null,
          message: ''
        }
        break
      case 'code':
        state.modal.validation.code = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },
  CLOSE_FUEL_LIST_MODAL: state => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = {
      id: null,
      message: ''
    }
    state.modal.code = ''
    state.modal.validation.code = {
      id: null,
      message: ''
    }
  }
}

const actions = {
  ...vuexLogistic.createActions(),

  saveFuelItem ({ commit, state, dispatch }) {
    const data = {
      name: state.modal.name,
      code: state.modal.code
    }

    switchCreateOrUpdate()
      .then(() => {
        commit('CLOSE_FUEL_LIST_MODAL')
        dispatch('loadList')
      })
      .catch(error => {
        commit('SET_FUEL_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления информационных типов', error.response)
      })

    function switchCreateOrUpdate () {
      if (state.modal.updatedId) {
        return updateItem(state.urlApi, state.modal.updatedId, data)
      }
      return createItem(state.urlApi, data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
